import { MAP_UUID_LABEL } from "../../store/common/constants";
import translations from "../../translations/resources/en-GB.json";
export var listDrop = [
    translations.data["venonboard.listView.dropDown.listItem2"],
    translations.data["venonboard.listView.dropDown.listItem3"],
];
export var valuesList = {
    mapName: translations.data["venonboard.listView.dropDown.listItem2"],
    mapcity: translations.data["venonboard.listView.dropDown.listItem3"],
};
export var COLLECTIONS = {
    COPY_MAP_ID: {
        LABEL: translations.data["venonboard.internalTools.copyMapID"],
    },
    COLLECTION_NAME: {
        LABEL: translations.data["venonboard.mapCollectionTab.name"],
    },
    VIEW: { LABEL: translations.data["venonboard.mapCollectionTab.view"] },
    CITY: {
        LABEL: translations.data["venonboard.form.city"],
    },
    INTERNAL_TABS: {
        LABEL: translations.data["venonboard.internalToolsTab2"],
    },
};
export var MAP_COLLECTION_TABLE_GEN_HEADERS = [
    {
        width: "40%",
        title: COLLECTIONS.COLLECTION_NAME.LABEL,
        id: "collectionName",
    },
    {
        width: "15%",
        title: MAP_UUID_LABEL,
        id: "mapUUID",
    },
    {
        width: "35%",
        title: COLLECTIONS.CITY.LABEL,
        id: "city",
    },
    {
        width: "",
        title: "",
        id: "viewDetails",
    },
];
